import {
  WB_FinishedProductRow,
  WB_ProductGroupRow,
  WB_TPM_EventMetricsRow, WB_TPM_EventProductMetricsRow,
  WB_TPM_EventProductGroupRow,
  WB_TPM_EventProductRow,
  WB_TPM_EventRow
} from "../PA.Core/PAdbSchemaRows";
import {BehaviorSubject} from "rxjs";
import {IMessageProvider, IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {TPMEventBO} from "../PA.TPM.BusinessObjects/TPMEventBO";
import {ITPMEventSpend} from "./PA.TPM.IF.TPM.EventSpend.Aspects";


export interface ITPMEventChangedEvent {
  TPMEventBO: TPMEventBO,
  Row: WB_TPM_EventRow,
  PropertyChanged: string,
  PropertyValue: any
}

export interface ITPMEvent {
  // Fire when WB_EventRow changes.
  readonly TPMEventPropertyChanged: BehaviorSubject<ITPMEventChangedEvent>;
}


export interface ITPMEventProductGroupChangedEvent {
  TPMEventBO: TPMEventBO,
  Row: WB_TPM_EventProductGroupRow,
  PropertyChanged: string,
  PropertyValue: any
}

export interface ITPMEventProductGroupsAddOptions {
    bOpenStockPrdGrp?: boolean,
    bDisplayCompPrdGrp?: boolean,
    bWithoutRefresh?: boolean
}

export interface ITPMEventProductGroupsRemoveOptions {
    bWithoutRefresh?: boolean
}


export interface ITPMEventProductGroups {

  addTPMEventProductGroup(wb_prdgrp_id: number | number[], options: ITPMEventProductGroupsAddOptions): Promise<WB_TPM_EventProductGroupRow[]>;

  removeTPMEventProductGroup(aWB_TEVTPG_ID: number | number[], options: ITPMEventProductGroupsRemoveOptions): Promise<void>;
  canRemoveTPMEventProductGroup(aWB_TEVTPG_ID: number): boolean

  readonly TPMEventProductGroupCollectionChanged: BehaviorSubject<ITPMEventProductGroups>;

  readonly TPMEventProductGroupPropertyChanged: BehaviorSubject<ITPMEventProductGroupChangedEvent>;

}



export interface ITPMEventProductChangedEvent {
  TPMEventBO: TPMEventBO,
  Row: WB_TPM_EventProductRow,
  PropertyChanged: string,
  PropertyValue: any
}

export interface ITPMEventProductsAddOptions {
  RowType?: string, // Don't specify unless you want to override
  ParentRowId?: number,
    bWithoutRefresh?: boolean
}

export interface ITPMEventProductsRemoveOptions {
    bWithoutRefresh?: boolean
}

export const ITPMEventProductsAddOptionsDefaults: ITPMEventProductsAddOptions = {
}


export interface ITPMEventProducts {

  addTPMEventProduct(wb_prod_id: number | number[], options: ITPMEventProductsAddOptions): Promise<WB_TPM_EventProductRow[]>;

  removeTPMEventProductRow(wb_tevtprd_id: number | number[], options?: ITPMEventProductsRemoveOptions): Promise<void>;
  canRemoveTPMEventProductRow(wb_tevtprd_id: number): boolean

  readonly TPMEventProductCollectionChanged: BehaviorSubject<ITPMEventProducts>;

  readonly TPMEventProductPropertyChanged: BehaviorSubject<ITPMEventProductChangedEvent>;

}






export interface IEventCalculatorCalculateOptions {
  bSkipSave?: boolean
}

export interface IEventCalculatorCalculateResults {

}

export interface IHaveTPMEventCalculator {
  readonly EventCalculator: ITPMEventCalculator
}

export interface ITPMEventCalculator {
  Register(aTPMEventBO: TPMEventBO): void
  UnRegister(): void

  readonly CalcProgressProvider: IProgressProvider
  readonly CalcMessageProvider: IMessageProvider

  Calculate(opts: IEventCalculatorCalculateOptions): Promise<IEventCalculatorCalculateResults>

  readonly bHasCalculateLift: boolean
  CalculateLift(): Promise<void>
}

export interface IHaveTPMEventStandardCalculator {
  readonly EventStandardCalculator: ITPMEventStandardCalculator
}

export interface IHaveTPMEventStandardCalculatorRefreshOptions
  extends
  IHaveTPMEventStandardCalculatorBaseMetricsUpdateOptions,
  IHaveTPMEventStandardCalculatorProductsSynchronizeOptions,
  IHaveTPMEventStandardCalculatorSpendSynchronizeOptions
{
}

export interface IHaveTPMEventStandardCalculatorBaseMetricsUpdateOptions {
  WB_TPM_EventProductGroupRows?: WB_TPM_EventProductGroupRow[],
  bIncludeVolume?: boolean,
  bIncludePricing?: boolean,
  bRunRowCalc?: boolean
}



export interface IHaveTPMEventStandardCalculatorProductsSynchronizeOptions {
  WB_TPM_EventProductGroupRows?: WB_TPM_EventProductGroupRow[],
  bIncludeRelatedFinishedProducts?: boolean
}

export interface IHaveTPMEventStandardCalculatorSpendSynchronizeOptions {
  TPMEventSpends?: ITPMEventSpend[]
  bIncludeSpendProductsSync?: boolean,
  bIncludeSpendProductGroupsSync?: boolean
}




export interface ITPMEventStandardCalculator {
  Register(aTPMEventBO: TPMEventBO): void
  UnRegister(): void

  readonly CalcProgressProvider: IProgressProvider
  readonly CalcMessageProvider: IMessageProvider

  Refresh(opts?: IHaveTPMEventStandardCalculatorRefreshOptions): Promise<void>
  BaseMetrics_update(opts?: IHaveTPMEventStandardCalculatorBaseMetricsUpdateOptions): Promise<void>
  Products_synchronize(opts?:IHaveTPMEventStandardCalculatorProductsSynchronizeOptions): Promise<void>

  Price_Event_Products(): Promise<void>

  Spend_synchronize(opts?:IHaveTPMEventStandardCalculatorSpendSynchronizeOptions): Promise<void>

}

export interface ITPMEventStandardCalculatorClientExtensionProvider {
  TPMEventStandardCalculatorExtensions: Promise<ITPMEventStandardCalculatorClientExtension[]>
  getTPMEventStandardCalculatorExtension(anExtensionId: string): Promise<ITPMEventStandardCalculatorClientExtension>
}

export interface ITPMEventStandardCalculatorClientExtension {
  readonly id: string,

  // Operation Defaults
  BaseMetricsUpdateOptionsDefault?: IHaveTPMEventStandardCalculatorBaseMetricsUpdateOptions
  ProductsSynchronizeOptionsDefault?: IHaveTPMEventStandardCalculatorProductsSynchronizeOptions

  SpendSynchronizeOptionsDefault?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions

  // EventBO Events
  OnEventBOLoaded?:(aTPMEventBO: TPMEventBO) => Promise<void>
  //OnProductGroupAdded?:(aTPMEventBO: TPMEventBO) => Promise<void>

  ProductGroup_RowCalcContextBefore?: (aTPMEventBO: TPMEventBO, context: {[id:string]: any}) => Promise<void>
  ProductGroup_RowCalcContext?: (aTPMEventBO: TPMEventBO, context: {[id:string]: any}) => Promise<void>
  ProductGroup_RowCalcContextAfter?: (aTPMEventBO: TPMEventBO, context: {[id:string]: any}) => Promise<void>


  ProductGroup_RowCalcBefore?: (aTPMEventBO: TPMEventBO, aRow: WB_TPM_EventProductGroupRow, context: any) => Promise<void>
  ProductGroup_RowCalc?: (aTPMEventBO: TPMEventBO, aRow: WB_TPM_EventProductGroupRow, context: any) => Promise<void>
  ProductGroup_RowCalcAfter?: (aTPMEventBO: TPMEventBO, aRow: WB_TPM_EventProductGroupRow, context: any) => Promise<void>
  ProductGroup_RowCalcCustom?: (aTPMEventBO: TPMEventBO, aRow: WB_TPM_EventProductGroupRow, CustomField: string, context: any) => Promise<void>

  // Event Level Property Change
  OnTPMEventPropertyChangeBefore?: (aTPMEventBO: TPMEventBO, change: ITPMEventChangedEvent) => Promise<void>
  OnTPMEventPropertyChange?: (aTPMEventBO: TPMEventBO, change: ITPMEventChangedEvent) => Promise<void>
  OnTPMEventPropertyChangeAfter?: (aTPMEventBO: TPMEventBO, change: ITPMEventChangedEvent) => Promise<void>

  // Event Product Group Property Change
  OnTPMEventProductGroupPropertyChangeBefore?: (aTPMEventBO: TPMEventBO, change: ITPMEventProductGroupChangedEvent) => Promise<void>
  OnTPMEventProductGroupPropertyChange?: (aTPMEventBO: TPMEventBO, change: ITPMEventProductGroupChangedEvent) => Promise<void>
  OnTPMEventProductGroupPropertyChangeAfter?: (aTPMEventBO: TPMEventBO, change: ITPMEventProductGroupChangedEvent) => Promise<void>

  // Event Product Property Change
  OnTPMEventProductPropertyChangeBefore?: (aTPMEventBO: TPMEventBO, change: ITPMEventProductChangedEvent) => Promise<void>
  OnTPMEventProductPropertyChange?: (aTPMEventBO: TPMEventBO, change: ITPMEventProductChangedEvent) => Promise<void>
  OnTPMEventProductPropertyChangeAfter?: (aTPMEventBO: TPMEventBO, change: ITPMEventProductChangedEvent) => Promise<void>

  // Event Spend Property Change
  // Event Spend Product Group Property Change
  // Event Spend Product Property Change


  // Synchronize Event Products from Product Groups
  SynchronizeEventProductsBefore?: (aTPMEventBO: TPMEventBO, context: any, opts?: IHaveTPMEventStandardCalculatorProductsSynchronizeOptions) => Promise<void>
  SynchronizeEventProducts?: (aTPMEventBO: TPMEventBO, context: any, opts?: IHaveTPMEventStandardCalculatorProductsSynchronizeOptions) => Promise<void>
  SynchronizeEventProductsAfter?: (aTPMEventBO: TPMEventBO, context: any, opts?: IHaveTPMEventStandardCalculatorProductsSynchronizeOptions) => Promise<void>


  // Event Spend Sync
  EventSpendSyncContextBefore?: (aTPMEventBO: TPMEventBO, context: {[id:string]: any}, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>
  EventSpendSyncContext?: (aTPMEventBO: TPMEventBO, context: {[id:string]: any}, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>
  EventSpendSyncContextAfter?: (aTPMEventBO: TPMEventBO, context: {[id:string]: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions}) => Promise<void>

  EventSpendSyncBefore?: (aTPMEventBO: TPMEventBO, aTPMEventSpend: ITPMEventSpend, context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>
  EventSpendSync?: (aTPMEventBO: TPMEventBO, aTPMEventSpend: ITPMEventSpend, context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>
  EventSpendSyncAfter?: (aTPMEventBO: TPMEventBO, aTPMEventSpend: ITPMEventSpend, context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>


  SynchronizeEventSpendProductGroupsBefore?: (aTPMEventBO: TPMEventBO, aTPMEventSpend: ITPMEventSpend, context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>
  SynchronizeEventSpendProductGroups?: (aTPMEventBO: TPMEventBO, aTPMEventSpend: ITPMEventSpend, context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>
  SynchronizeEventSpendProductGroupsAfter?: (aTPMEventBO: TPMEventBO, aTPMEventSpend: ITPMEventSpend, context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>

  SynchronizeEventSpendProductsBefore?: (aTPMEventBO: TPMEventBO, aTPMEventSpend: ITPMEventSpend, context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>
  SynchronizeEventSpendProducts?: (aTPMEventBO: TPMEventBO, aTPMEventSpend: ITPMEventSpend, context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>
  SynchronizeEventSpendProductsAfter?: (aTPMEventBO: TPMEventBO, aTPMEventSpend: ITPMEventSpend, context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions) => Promise<void>

  // Allow for other helper methods
  [id:string]: any
}

export interface IHaveTPMEventMetricsChangedEvent {
    IHaveTPMEventMetrics: IHaveTPMEventMetrics,
    Row: WB_TPM_EventMetricsRow,
    PropertyChanged: string,
    PropertyValue: any
}

export interface IHaveTPMEventMetrics {
    //
    readonly bIHaveTPMEventMetricsLoaded: boolean
    readonly OnIHaveTPMEventMetricsLoaded: Promise<void>;

    readonly TPMEventMetrics: WB_TPM_EventMetricsRow[]

    TPMEventMetricsProgressProvider: IProgressProvider
    //PlanVolumeMetricsMessageProvider: IMessageProvider
    //EventMetrics_sync(): void
    // Product Group Load Operations
    pauseLoadProcessing(): void
    resumeLoadProcessing(): void

    loadAllProductGroups(): void
    loadProductGroups(arrWBPGIds: number[]): void

    readonly ProductGroups: WB_ProductGroupRow[];
    readonly ProductGroupsLoaded: WB_ProductGroupRow[]
    readonly ProductGroupsAllLoaded: boolean
    readonly ProductGroupsLoadProgressProvider: IProgressProvider


    readonly TPMEventMetricsCollectionChanged: BehaviorSubject<IHaveTPMEventMetrics>
    readonly TPMEventMetricsPropertyChanged: BehaviorSubject<IHaveTPMEventMetricsChangedEvent>;

}

export interface IHaveTPMEventProductMetricsChangedEvent {
  IHaveTPMEventProductMetrics: IHaveTPMEventProductMetrics,
  Row: WB_TPM_EventProductMetricsRow,
  PropertyChanged: string,
  PropertyValue: any
}

export interface IHaveTPMEventProductMetrics {
  //
  readonly bIHaveTPMEventProductMetricsLoaded: boolean
  readonly OnIHaveTPMEventProductMetricsLoaded: Promise<void>;

  readonly TPMEventProductMetrics: WB_TPM_EventProductMetricsRow[]

  TPMEventProductMetricsProgressProvider: IProgressProvider
  //PlanVolumeMetricsMessageProvider: IMessageProvider
  //EventMetrics_sync(): void
  // Product Group Load Operations
  pauseLoadProcessing(): void
  resumeLoadProcessing(): void

  loadAllProductGroups(): void
  loadProductGroups(arrWBPGIds: number[]): void

  readonly Products: WB_FinishedProductRow[];
  readonly ProductsLoaded: WB_FinishedProductRow[]
  readonly ProductsAllLoaded: boolean
  readonly ProductsLoadProgressProvider: IProgressProvider


  readonly TPMEventProductMetricsCollectionChanged: BehaviorSubject<IHaveTPMEventProductMetrics>
  readonly TPMEventProductMetricsPropertyChanged: BehaviorSubject<IHaveTPMEventProductMetricsChangedEvent>;

}

